// extracted by mini-css-extract-plugin
export default {"table":"H5J8kFZHHVHONrqDbzRg","submitBtn":"aoJUOJt81lt6pZG3yghL","error":"FimlhCz9RNmSYdXANYfs","sending":"wGwe3BtukEwApjw9J3zh","complete":"lOFyzi1TCJ25Q3CIdX7M"};